import { TbMovie } from "react-icons/tb";

import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";
import { FV_ROUTE_PERMISSIONS } from "@/pages/feature-videos/constants";

export const featureVideosRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.FEATURE_VIDEOS,
        meta: {
            label: "feature_videos",
            order: 9,
            icon: TbMovie,
            visibleInSidebar: true,
            permissions: FV_ROUTE_PERMISSIONS,
        },
    },
];
